import React, { FC } from 'react';

import {
  Box,
  Flex,
  Stack,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react';

import { Form, Formik } from 'formik';

import FormikInput from 'components/primitives/FormikInput';
import FormikSelectInput from 'components/primitives/FormikSelectInput';

import { selectors } from 'store/slices/washhub';

import { getInitialValues, validationSchema } from './EditCaseModal.utils';

import { Status } from 'types/items';
import { EditCaseModalViewProps } from './EditCaseModal.props';

const labelProps = {
  fontSize: '12px',
  color: '#afafaf',
};

const EditCaseModalView: FC<EditCaseModalViewProps> = (props) => {
  const {
    skus,
    _case,
    isOpen,
    onClose,
    onSubmit,
    isLoading,
    isLoadingSKU,
  } = props;

  const washHub = selectors.useSelectedWashHub();

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader textAlign="center" fontWeight="500">
          Update case - {_case?._id}
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" px={6} pb={6}>
            <Formik
              onSubmit={onSubmit}
              initialValues={getInitialValues(_case)}
              validationSchema={validationSchema}>
              {({ values }) => (
                <Form>
                  <Flex direction="column">
                    <Flex mb={4}>
                      <FormikSelectInput
                        placeholder="Select"
                        label="Select SKU (*)"
                        isLoading={isLoadingSKU}
                        containerProps={{ flex: 1 }}
                        name="sku"
                        labelProps={labelProps}>
                        {skus?.map((sku) => (
                          <option key={sku._id} value={sku._id}>
                            {sku?.name || ''}
                          </option>
                        ))}
                      </FormikSelectInput>
                      <Box h="20px" w="20px" />
                      <FormikSelectInput
                        placeholder="Select"
                        label="Status"
                        containerProps={{ flex: 1 }}
                        name="status"
                        maxW="250px"
                        labelProps={labelProps}>
                        {Object.values(Status)
                          .filter((status) => typeof status === 'string')
                          .map((status, index) => (
                            <option key={status} value={index}>
                              {status || ''}
                            </option>
                          ))}
                      </FormikSelectInput>
                    </Flex>
                    {Status[values?.status] === 'PACKED' ? (
                      <FormikInput
                        name="packageId"
                        label="Package ID"
                        labelProps={labelProps}
                        containerProps={{ flex: 1 }}
                        value={_case?.currentPackage}
                      />
                    ) : (
                      <></>
                    )}
                    <FormikInput
                      name="washHub"
                      label="Wash Hub"
                      labelProps={labelProps}
                      isReadOnly
                      containerProps={{ flex: 1 }}
                      value={washHub?.name || ''}
                    />
                    <FormikInput
                      name="rfid"
                      label="RFID"
                      labelProps={labelProps}
                      containerProps={{ flex: 1 }}
                      bg="#f1f1f1"
                    />
                  </Flex>
                  <Stack mt={6} align="center" isInline justify="center">
                    <Button
                      variant="outline"
                      w="200px"
                      onClick={onClose}
                      isDisabled={isLoading}>
                      Cancel
                    </Button>
                    <Button type="submit" w="200px" isLoading={isLoading}>
                      Update
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditCaseModalView;
